// computeDraftDiff compares a draft hierarchy against the active one, matched by stable code,
// and classifies each draft node as added / moved / renamed / unchanged. Nodes present in the
// active version but absent from the draft are reported as `removed` (they have no place in the
// draft tree, so the UI surfaces them as a count rather than ghost nodes).
//
// Each input is a list of { code, name, parentCode } (parentCode null for top-level nodes).
// "moved" takes precedence over "renamed" when both changed — a reparenting is the more
// structurally significant change.
export function computeDraftDiff(activeList, draftList) {
  const activeByCode = new Map(activeList.map((n) => [n.code, n]));
  const draftCodes = new Set(draftList.map((n) => n.code));

  const byCode = {};
  const counts = { added: 0, moved: 0, renamed: 0, removed: 0 };

  for (const d of draftList) {
    const a = activeByCode.get(d.code);
    let kind;
    if (!a) {
      kind = "added";
    } else if ((a.parentCode ?? null) !== (d.parentCode ?? null)) {
      kind = "moved";
    } else if (a.name !== d.name) {
      kind = "renamed";
    } else {
      kind = "unchanged";
    }
    byCode[d.code] = kind;
    if (kind !== "unchanged") counts[kind] += 1;
  }

  const removed = activeList.map((n) => n.code).filter((code) => !draftCodes.has(code));
  counts.removed = removed.length;

  return { byCode, removed, counts };
}
